import React, { useState } from "react";
import PropTypes from "prop-types";

import { useField } from "formik";

import { IconContainer } from "shipnow-mercurio";

const N_STARS = 5;

export const RatingInputFormik = (props) => {
  const { iconProps, name } = props;

  const [iconHovered, setIconHovered] = useState(0);
  const [isPressed, setIsPressed] = useState(false);

  // eslint-disable-next-line no-unused-vars
  const [field, meta, helpers] = useField(name);

  const handleIconProps = (star, hovered) => {
    //?pressed
    if (isPressed && star <= hovered) {
      return {
        color: "primaryDarkPressed",
        icon: "starStroke",
        size: "spot",
      };
    }

    //? hover
    if (star <= hovered) {
      return {
        color: "primary",
        icon: "starStroke",
        size: "spot",
      };
    }

    //? selected
    if (hovered === 0 && star <= meta.value) {
      return {
        color: "primary",
        icon: "starFull",
        size: "spot",
      };
    }

    //? default icon props.
    return {
      color: "blackBorder",
      icon: "starStroke",
      size: "spot",
    };
  };

  const handleClick = (stars) => {
    helpers.setValue(stars);
    resetHovered();
  };

  const setHoveredRating = (stars) => {
    setIconHovered(stars);
  };

  const resetHovered = () => {
    setIconHovered(0);
  };

  return (
    <>
      {Array.from({ length: N_STARS }, (_, index) => {
        const starNumber = index + 1;

        return (
          <IconContainer
            {...handleIconProps(starNumber, iconHovered)}
            {...iconProps}
            key={`${name}--rating-star-${starNumber}`}
            margin={index === N_STARS - 1 ? "a-0" : "r-8"}
            onClick={() => handleClick(starNumber)}
            onMouseDown={() => setIsPressed(true)}
            onMouseEnter={() => setHoveredRating(starNumber)}
            onMouseLeave={() => {
              resetHovered();
              setIsPressed(false);
            }}
            onMouseUp={() => setIsPressed(false)}
          />
        );
      })}
    </>
  );
};

RatingInputFormik.propTypes = {
  iconProps: PropTypes.object,
  name: PropTypes.string.isRequired,
};

RatingInputFormik.defaultProps = {
  iconProps: null,
  name: "",
};
